// 可能需要disable eslint错误
// eslint-disable-next-line
if (window.__POWERED_BY_QIANKUN__) {
  console.log('window.__POWERED_BY_QIANKUN__');
  // 修改运行时publicPath
  // eslint-disable-next-line
    __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}
